var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-menu__contacts"},[_c('div',{staticClass:"footer-menu__phone"},[_c('a',{staticClass:"footer-menu__phone-link",attrs:{"href":'tel:' + _vm.contactPhone}},[_vm._v(_vm._s(_vm.contactPhone))]),_c('p',{staticClass:"footer-menu__text"},[_vm._v(_vm._s(_vm.$t('footer_free_phone')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }